import { FC, useEffect, useState} from "react"
import { useTranslation } from "react-i18next";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ReactPlayer from 'react-player'
import { useWindowWidthAndHeight } from "../../shared/hooks/customHooks";
import './homeCardStyle.css'
import { useSelector } from "react-redux";
import { getUrlVideo } from "../../redux/selectors/appGlobalSelector";
interface IProps{
    handleClose:()=> void;
}
const VideoModal:FC<IProps>=({handleClose})=>{
    const { t } = useTranslation();
    const urlVideoConfig = useSelector(getUrlVideo);
    const style = { color: "#133E5E", fontSize: "2em" }
    const [width] = useWindowWidthAndHeight();
    const [videoHeight, setVideoHeight]=useState<number>(width/2)
    const [videoWidth, setVideoWidth]=useState<number>(width/2)
    const [urlVideo, setUrlVideo] = useState<string>("");

    useEffect(() => {
      setUrlVideo(urlVideoConfig);
    }, [urlVideoConfig]);

    useEffect(()=>{
      if(width<800){
        setVideoHeight(width/2)
        setVideoWidth(width/1.5)
      }
      else{
        setVideoHeight(width/4)
        setVideoWidth(width/2)
      }
    },[width]);

    useEffect(() => {
      const handleKey = (event: KeyboardEvent) => {
        if (event.code === '27' || event.key === 'Escape') {
          handleClose();
        }
      }
      window.addEventListener('keydown', handleKey);
      return () => window.removeEventListener('keydown', handleKey);
    }, [])

    return( <>
        <div className='darkBG' onClick={() => handleClose()} />
        <div 
          className="video-centered"
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          aria-label="Vidéo présentant la notion d'espérance de vie"
        >
          <div className="modal">
            <div className="modalHeader">
              <h5 className="heading">{t('ev_question')}</h5>
              <button 
                className="closeBtn" 
                onClick={() => handleClose()}
                aria-label="Fermer la popup"
              >
                <AiOutlineCloseCircle style={style}/>
              </button>
            </div>
            <div className="player-container">
                <ReactPlayer 
                  controls={true}
                  width={videoWidth}
                  height={videoHeight}
                  url={urlVideo}
                  playing={true}
                />
            </div>
          </div>
        </div>
      </>)
}

export default VideoModal